import { IResponse } from "models";

export enum ActionType {
  MINI_STRESS_SCORING = "action/MINI_STRESS_SCORING",
  MINI_STRESS_SCORING_SUCCESS = "action/MINI_STRESS_SCORING_SUCCESS",
  MINI_STRESS_SCORING_ERROR = "action/MINI_STRESS_SCORING_ERROR",
  MINI_STRESS_SCORING_RESET = "action/MINI_STRESS_SCORING_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

interface IStressItem {
  name: string;
  low: boolean;
  slightly_low: boolean;
  normal: boolean;
  slightly_high: boolean;
  high: boolean;
  rating_point: number;
}

export interface IMiniStressScoringPayload {
  stress_check_id: string;
}

export interface IMiniStressScoring {
  user_information?: {
    name: string;
    designation: string;
    age: string;
    gender: string;
    stress_assessment_result: string;
  };
  point_information?: {
    stress_factor: number;
    mental_physical: number;
    cause_of_stress: number;
    total: number;
  };
  stress_results?: {
    group8?: {
      order_5_to_1: IStressItem[];
      order_1_to_5: IStressItem[];
    };
    group9?: {
      order_5_to_1: IStressItem[];
    };
    group10?: {
      order_1_to_5: IStressItem[];
    };
  };
}

export interface IMiniStressScoringResponse extends IResponse {
  result: IMiniStressScoring;
}
